import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { injectIntl } from 'react-intl';
import AddClassModal from './AddClassModal';
import messages from '../../ScheduleForm.messages';
import { createClass } from '../../../Schedules.saga';

const validate = (values, props) => {
  const {
    intl: { formatMessage },
  } = props;
  const errors = {};
  if (!values.name) {
    errors.name = formatMessage(messages.validator.requiredField);
  }

  if (!values.description) {
    errors.description = formatMessage(messages.validator.classDescriptionRequired);
  }

  return errors;
};

const mapDispatchToProps = {
  onSubmit: createClass,
};

export default compose(
  connect(null, mapDispatchToProps),
  injectIntl,
  reduxForm({
    form: 'ADD_CLASS_FORM',
    validate,
  })
)(AddClassModal);
